export enum Mode {
    b2b_mobile = 'b2b_mobile',
    b2c_mobile = 'b2c_mobile',
    b2b_desktop = 'b2b_desktop',
    b2c_desktop = 'b2c_desktop',
    pro_app = 'pro_app',
}
